// Site Types and Interfaces

export interface Site {
  siteId: string;
  locationCode: string;
  oldLocationCode: string;
  state: string;
  locationDescription: string;
  locationAddress: string;
  region: string;
  locationType: string;
  locationStatus: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
}

export interface CreateSiteRequest {
  locationCode: string;
  oldLocationCode: string;
  state: string;
  locationDescription: string;
  locationAddress: string;
  region: string;
  locationType: string;
  locationStatus: string;
}

export interface UpdateSiteRequest extends CreateSiteRequest {
  siteId: string;
}

export interface SiteFormData {
  siteId?: string;
  locationCode: string;
  oldLocationCode: string;
  state: string;
  locationDescription: string;
  locationAddress: string;
  region: string;
  locationType: string;
  locationStatus: string;
}

export interface SiteResponse {
  message: string;
  siteId?: string;
  site?: Site;
}

export interface SitesListResponse {
  totalCount: number;
  page: number;
  limit: number;
  sites: Site[];
}

// Dropdown Options
export const STATE_OPTIONS = [
  { value: "tamilnadu", label: "Tamil Nadu" },
  { value: "karnataka", label: "Karnataka" },
  { value: "pondicherry", label: "Pondicherry" },
];

export const REGION_OPTIONS = [
  { value: "north", label: "North" },
  { value: "south", label: "South" },
];

export const LOCATION_TYPE_OPTIONS = [
  { value: "small_properties", label: "Small Properties" },
  { value: "big_properties", label: "Big Properties" },
];

export const LOCATION_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];
